import React, { Component } from 'react';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody} from 'reactstrap';
import WarningMessage from './../../Message/WarningMessage/WarningMessage'

class InvitedAdminModal extends Component {

  constructor(props) {
    super(props);
  }

  populateInvitedAdmins = () => {
    const {invitedAdmins,selectedOffice,removeAdminCta, userEmail} = this.props;
    // console.log(selectedOffice);
    return invitedAdmins.map((row) => {
      const officePath = selectedOffice.officeHierarchyPath ? selectedOffice.officeHierarchyPath : 
        selectedOffice.officePath ? selectedOffice.officePath : null;
      return(
        <div className="invited-user-row" key={row.email} style={{display:'flex',justifyContent:'space-between',padding:'10px 30px'}}>
          <div className="invited-email-row">
            {row.email}
          </div>
          {userEmail !== row.email && <div className="invited-cta cursor-pointer" 
          onClick={() => this.props.onCancelInvitation(row,officePath)}>
            {
              row.removed && row.hasLoggedIn && removeAdminCta ? 
              <div style={{color:'#F38F81'}}>(admin removed)</div> :
              row.removed ?
              <div style={{color:'#F38F81'}}>(invitation cancelled)</div> :
              row.hasLoggedIn && removeAdminCta ?
              `Remove Admin` :
              `Cancel Invitation`
            }
          </div>}
        </div>
      )
    })
  }

  render() { 
    const {modalDataUpdated} = this.props;
    const officeName = this.props.selectedOffice.officeHierarchyPath ? this.props.selectedOffice.officeHierarchyPath.split('#').pop() :
    this.props.selectedOffice.officePath ? this.props.selectedOffice.officePath.split('#').pop() : '';
    return ( 
      <div>
        <div className="pick-office-modal-body-title">
          {officeName} Admins
        </div>
        <div className="mt20">
          {
            this.populateInvitedAdmins()
          }
        </div>
        {
          modalDataUpdated ? 
          <div className="mt10">
          <WarningMessage msg="You made some changes that need to be saved. Note: if an office only has one admin, you will not be able to remove them before you invite another admin."/></div> : null
        }
        <div className="row mt20">
          {
            modalDataUpdated ? 
            <div className="col-lg-4 col-md-4">
              <Button onClick={() => this.props.toggle('_SAVE_')} color="primary" style={{width:'100%'}}>
                <span style={{fontSize:'18px',lineHeight:'25px'}}>Save</span>
              </Button>
            </div> : null
          }
          <div className="col-lg-2 col-md-2">
            <Button onClick={() => this.props.toggle('_CLOSE_')} color="secondary-filled" style={{width:'100%'}}>
              <span style={{fontSize:'18px',lineHeight:'25px'}}>Close</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
 
export default InvitedAdminModal;